export const SWAPS = [
  {
    chain_id: 4,
    contract_addr: '0xbCe75beCb029AA8465494bBFd44862612c8b9d30',
    fee_bps: 10,
  },
];
